<template>
  <section role="region" class="our-features-section" id="our-features">
    <div class="content">
      <div class="text">
        <TheSecondHead chipText="Diferenciais" chipColor="white" titleText="Nossas funcionalidades" />
        <div class="functionalities">
          <div class="funcionality" v-for="feature in functionalities" :key="feature.id" :id="`feature-${feature.id}`">
            <div class="circle">
              <TheIcon :icon="feature.mediaSrc || ''" :size="feature.mediaSize || 0" type="svg" />
            </div>
            <p class="subtitle">{{ feature.title }}</p>
            <p class="paragraph">{{ feature.text }}</p>
          </div>
        </div>
      </div>
      <div class="image">
        <ThePicture mobilePath="/images/business/m-computer.png"
          tabletPath="/images/business/t-computer.png"
          desktopPath="/images/business/computer.png" mobileQuerie="834px" desktopQuerie="960px"
          altText="Notebook" />
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">


const functionalities = ref<Array<ContentCardItem>>([
  {
    id: 1,
    mediaSrc: '/icons/business/ruler.svg',
    mediaSize: '30',
    title: 'Configure réguas inteligentes',
    text: 'Mantenha seu cliente engajado e acompanhe todo o ciclo de vida',
  },
  {
    id: 2,
    mediaSrc: '/icons/business/signal.svg',
    mediaSize: '26',
    title: 'Escalabilidade',
    text: 'Cresça de maneira sustentável, sem se preocupar.',
  },
  {
    id: 3,
    mediaSrc: '/icons/business/paper-plane.svg',
    mediaSize: '24',
    title: 'Omnichannel/Full Channel',
    text: 'Estar no canal de preferência do seu cliente faz toda a diferença',
  },
  {
    id: 4,
    mediaSrc: '/icons/business/cog.svg',
    mediaSize: '24',
    title: 'Gestão centralizada das ações',
    text: 'Customize e analise tudo no mesmo lugar',
  },
])

const setActiveItem = (element: HTMLElement) => {
  if (window.scrollY >= ((element.offsetTop / 2)) && !element.classList.contains("in-view")) {
    element.classList.add("in-view");
  } else if (window.scrollY < ((element.offsetTop / 2)) && element.classList.contains("in-view")) {
    element.classList.remove("in-view");
  }
}

const ourFaturesWatcher = () => {
  functionalities.value.forEach(item => {
    var element: any = document.getElementById(`feature-${item.id}`);
    setActiveItem(element);
  });
}

onMounted(() => {
  window.addEventListener('scroll', ourFaturesWatcher, {passive: true});
  ourFaturesWatcher();
})

onBeforeUnmount(() => {
  window.removeEventListener('scroll', ourFaturesWatcher);
})
</script>

<style lang="scss">
@use "@/styles/variables" as *;

.our-features-section {
  max-width: none;
  background: #d2dcff80;
}

.our-features-section .content {
  max-width: 971px;
  margin: 0 auto;
  padding: 40px 18px 40px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;

  .text {
    .headline {
      .title {
        margin: 16px 0px 30px;
        font-size: 40px;
        line-height: 110%;
      }
    }

    .functionalities {
      padding-left: 24px;
      margin-bottom: 40px;

      .funcionality {
        padding-left: 48px;

        &:not(:last-child) {
          padding-bottom: 24px;
          border-left: 2px dashed $greyDark;
          -webkit-transition: all 0.75s ease-out 0.75s;
          -moz-transition: all 0.75s ease-out 0.75s;
          -o-transition: all 0.75s ease-out 0.75s;
          transition: all 0.75s ease-out 0.75s;
        }

        &:nth-child(4) .paragraph {
          width: 75%;

          @media screen and (min-width: 470px) {
            width: unset;
          }
        }

        .circle {
          position: absolute;
          margin-left: -73px;
          background-color: $greyDark;
          -webkit-transition: all 1s linear;
          -moz-transition: all 1s linear;
          -o-transition: all 1s linear;
          transition: all 1s linear;
          border-radius: 100%;
          width: 48px;
          height: 48px;
          display: flex;
          justify-content: center;
          align-items: center;
        }

        .subtitle {
          font-weight: 700;
          margin-bottom: 8px;
          line-height: normal;
        }

        .subtitle,
        .paragraph {
          color: $black;
        }
      }
    }
  }

  .image {
    text-align: center;

    .image-component img {
      margin: 0 auto;
      width: 278px;
      height: 299px;
    }
  }

  @media screen and (min-width: 834px) and (max-width: 959px) {
    padding: 70px 34px 95px 33px;

    .text .functionalities {
      padding-right: 13px;

      .funcionality {
        .circle {
          margin-left: -77px;
        }
      }
    }

    .image .image-component img {
      width: 269px;
      height: 329px;
      margin-right: 69px;
    }
  }

  @media screen and (min-width: 960px) and (max-width: 1199px) {
    padding: 68px 52px 68px 32px;
    justify-content: center;

    .text .functionalities {
      padding-right: 26px;
    }

    .image .image-component img {
      width: 420px;
      height: 451px;
      margin-right: 14px;
    }
  }

  @media screen and (min-width: 834px) {
    flex-direction: row-reverse;

    .text .functionalities {
      padding-left: 28px;
      margin-bottom: 0px;

      .funcionality {
        padding-left: 72px;

        .circle {
          width: 56px;
          height: 56px;
          margin-left: -101px;
        }

        .subtitle {
          font-size: 18px;
        }
      }
    }
  }

  @media screen and (min-width: 960px) {
    align-items: flex-end;
  }

  @media screen and (min-width: 1200px) {
    padding: 68px 0px;
    justify-content: space-between;

    .text .functionalities {
      width: 399px;

      .funcionality {
        .subtitle {
          letter-spacing: 0.18px;
        }

        .paragraph {
          letter-spacing: 0.16px;
        }
      }
    }

    .image .image-component img {
      width: 420px;
      height: 451px;
    }
  }

  .in-view {
    border-color: $blue !important;

    .circle {
      background-color: $blue !important;
    }
  }
}
</style>